export var DeviceCommandType;
(function (DeviceCommandType) {
    DeviceCommandType[DeviceCommandType["RefreshDeviceConfiguration"] = 0] = "RefreshDeviceConfiguration";
    DeviceCommandType[DeviceCommandType["RefreshDeviceBrowsers"] = 1] = "RefreshDeviceBrowsers";
})(DeviceCommandType || (DeviceCommandType = {}));
